
import daphne from '@didi/daphne-sdk-javascript'
import { isEqual } from 'lodash-es'
import storage from 'didi-store'
export async function getGuidance ({ commit }, params = {}) {
  let { host } = window.location
// 当前host是pre环境
const inPre = host.indexOf('pre-') === 0
const isSimEnv = host.startsWith('sim')
  const oldGuidanceConfig = storage.get('guidance_config');
  let daphneDebug = {
    ns: 'sailing_m_services_bdapp', // 命名空间
    name: 'guidance-config', // 配置名称
    key: 'janejianjie'
  }
  // if (inPre||isSimEnv) {
  //   daphneDebug.debug = true;
  //   }
  //   console.log(daphneDebug,'daphneDebug')
  const result = await daphne.getToggle(daphneDebug)
  let guidanceConfig = {}
  if (result?.data?.['guidance-config']?.params) {
    guidanceConfig = result.data['guidance-config'].params
    const isEqualConfig=isEqual(oldGuidanceConfig,guidanceConfig)
    if(!isEqualConfig){
      console.log(guidanceConfig,'guidanceConfig')
      storage.set('guidance_config',guidanceConfig)
    }
  } else {
    console.log('noguidanceConfig')
  }

}
